import { Component, OnInit } from '@angular/core';



@Component({
  selector: 'app-usuario-detail',
  templateUrl: './usuario-detail.component.html',
  styleUrls: ['./usuario-detail.component.css']
})
export class UsuarioDetailComponent implements OnInit {

  
  constructor() { }

  ngOnInit() {
  }

  

}
